import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { MermaidRenderer } from '../MdTextComponent/MermaidRenderer'
import { cn } from '@/lib/utils'

export function ListCardMarkdown({ content, className }: { content: string; className?: string }) {
  return (
    <div className={cn('prose prose-sm max-w-none dark:prose-invert', className)}>
      <Markdown
        remarkPlugins={[remarkGfm]}
        components={{
          pre({ children, ...props }) {
            const codeElement = children as React.ReactElement
            if (codeElement?.props?.className?.includes('language-mermaid')) {
              return <MermaidRenderer chart={String(codeElement.props.children).replace(/\n$/, '')} />
            }
            return <pre {...props}>{children}</pre>
          },
          code({ className: codeClassName, children, ...props }) {
            return (
              <code className={codeClassName} {...props}>
                {children}
              </code>
            )
          },
        }}
      >
        {content}
      </Markdown>
    </div>
  )
}
